import { USER_ROLES } from "../../../../shared/auth/roles";

export const PERICIA_UPDATE_SECTIONS = {
  PRICE_TABLE: "price_table",
  REPAIR_MANAGEMENT: "repair_management",
  REPAIR_RECORDS: "repair_records",
  INVOICE_REFERENCE: "invoice_reference",
  CASH_PAYMENT: "cash_payment",
  TABLE_PDF: "table_pdf",
  COMMERCIAL_ACTIONS: "commercial_actions",
  DELETE: "delete"
} as const;

export type PericiaUpdateSection = (typeof PERICIA_UPDATE_SECTIONS)[keyof typeof PERICIA_UPDATE_SECTIONS];

export const PERICIA_UPDATE_SECTION_ROLES: Record<PericiaUpdateSection, readonly string[]> = {
  [PERICIA_UPDATE_SECTIONS.PRICE_TABLE]: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN],
  [PERICIA_UPDATE_SECTIONS.REPAIR_MANAGEMENT]: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN],
  [PERICIA_UPDATE_SECTIONS.REPAIR_RECORDS]: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN, USER_ROLES.LIMITED_ADMIN],
  [PERICIA_UPDATE_SECTIONS.INVOICE_REFERENCE]: [
    USER_ROLES.ADMIN,
    USER_ROLES.SALESMAN,
    USER_ROLES.LIMITED_ADMIN,
    USER_ROLES.PERICIA_CREATOR,
    USER_ROLES.USER_PRIVILEGED
  ],
  [PERICIA_UPDATE_SECTIONS.CASH_PAYMENT]: [USER_ROLES.ADMIN],
  [PERICIA_UPDATE_SECTIONS.TABLE_PDF]: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN, USER_ROLES.LIMITED_ADMIN],
  [PERICIA_UPDATE_SECTIONS.COMMERCIAL_ACTIONS]: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN, USER_ROLES.LIMITED_ADMIN],
  [PERICIA_UPDATE_SECTIONS.DELETE]: [USER_ROLES.ADMIN]
};

export const canDisplayPericiaUpdateSection = (role: string | undefined, section: PericiaUpdateSection) =>
  PERICIA_UPDATE_SECTION_ROLES[section].includes(role || USER_ROLES.USER);

